import {UserApi} from '@intelingu/core/api/UserApi';
import {HttpClient} from '@intelingu/core/configs/axios.config';
import {action, observable, reaction} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {Component} from 'react';
import {Route, Switch} from 'react-router';
import {lazyInject} from '@intelingu/core/IoC/container';
import {bindRouter} from '@intelingu/core/utils/bindRouter';
import {CourseStore} from '@intelingu/core/stores/CourseStore';
import {SubscriptionStore} from '@intelingu/core/stores/SubscriptionStore';
import {UserStore} from '@intelingu/core/stores/UserStore';
import {ProtectedRoute} from '@intelingu/core/components/ProtectedRoute';
import {CourseLayout} from './course/CourseLayout';
import {ProfileLayout} from './profile/ProfileLayout';
import {SessionLayout} from './profile/SessionLayout';
import {AppStore} from "../stores/AppStore";
import {CourseApi} from "@intelingu/core/api/CourseApi";
import {BootstrapStore} from "../stores/BootstrapStore";
import {StRegisterLayout} from "./profile/StRegisterLayout";
import moment from "moment";
import {AnalyticsStore} from "../stores/AnalyticsStore";

export interface RouterProps {
    location?;
}

declare const window;

@bindRouter
class ScrollToTop extends Component<any, any> {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0)
        }
    }

    render() {
        return this.props.children
    }
}

@bindRouter
@observer export class Router extends Component<RouterProps, any> {

    @lazyInject(CourseStore) courseStore: CourseStore;
    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(SubscriptionStore) subscriptionStore: SubscriptionStore;
    @lazyInject(UserApi) userApi: UserApi;
    @lazyInject(CourseApi) courseApi: CourseApi;
    @lazyInject(HttpClient) httpClient: HttpClient;
    @lazyInject(AppStore) appStore: AppStore;
    @lazyInject(BootstrapStore) bootstrapStore: BootstrapStore;
    @lazyInject(AnalyticsStore) analyticsStore: AnalyticsStore;

    @observable isReady = false;
    isTokenLoaded = false;

    async componentDidMount() {
        /*reaction(() => this.bootstrapStore.isLoaded, () => {
            if (this.isTokenLoaded) {
                this.isReady = false;
            }
        });*/

        await this.httpClient.refreshToken();
        this.isTokenLoaded = true;

        // await this.userStore.loadProfile();
        this.bootstrap();
    }

    @action.bound async bootstrap() {
        try {
            await this.bootstrapStore.bootstrap();
            this.trackSubscribed();

            this.userStore.isReady = true;
        } catch (e) {
            // not authorized
        }

        // this.isReady = !!this.userStore.user;
        this.isReady = true;
    }

    trackSubscribed() {
        if (window.location.href.includes('digithankyou')) {
            this.analyticsStore.trackSubscribed();
            return;
        }

        if (!this.subscriptionStore.subscriptions) {
            return;
        }

        const list = this.subscriptionStore.subscriptions.filter(item => item.is_trial_native);

        if (!list.length) {
            return;
        }

        if (!this.userStore.user.options.trial_tracked && moment().isAfter(moment.unix(list[0].order_date).add(7, 'days'))) {
            this.analyticsStore.trackSubscribed();
            this.userApi.setOption('trial_tracked', '1');
        }
    }

    render() {
        if (!this.isReady) {
            return null;
        }

        /*if (!this.subscriptionStore.hasActiveSubscriptions &&
            // !this.props.location.pathname.match(/\/(subscriptions|session|profile)/)
            this.props.location.pathname.match(/\/(course)/)
        ) {
            return <Redirect to={'/subscriptions'} />
        }*/

        return <ScrollToTop>
            <Switch>
                <Route path={`/session`} component={SessionLayout} />
                <Route path={`/st`} component={StRegisterLayout} />
                <ProtectedRoute path={`/course`} component={CourseLayout} />
                <ProtectedRoute path={`/`} component={ProfileLayout} />
            </Switch>
        </ScrollToTop>
    }

}
